<template>
	<div>
		<gmap-map ref="gmap"
		          :center="{lat : 49.8887211, lng : 12.2793155}"
		          :options="mapOptions"
		          :zoom="20"
		          style="width: 100%; height: 600px;"
		          @idle="boundMap"
		>
			<gmap-info-window
					:position="infoWindow.position"
					:opened="infoWindowOpen"
					:options="infoWindow.options"
					@closeclick="infoWindowOpen=false">
				<h3 v-html="infoWindow.title"></h3>
				<p v-html="infoWindow.text"></p>
			</gmap-info-window>
			<gmap-marker
					v-for="(place,idx) in filteredPlaces"
					:key="place.uid"
					:position="{ lat: place.latitude, lng: place.longitude}"
					:clickable="true"
					:icon="getIcon(place.categories)"
					@click="toggleInfoWindow(place, idx)"
			></gmap-marker>
		</gmap-map>

	</div>
</template>

<script>

	export default {
		name: "KappPlace",
		data() {
			return {
				mapStyle : require( '@/assets/map_style'),
				infoWindowOpen : false,
				infoWindow : {
					title: '',
					position : null
				},
				mapOptions : {
					disableDefaultUI: true,
					styles : require( '@/assets/map_style')[this.$store.getters.getViewMode]
				},
				mapBounds : false,
				activeInfo : null,
				categoryFilter : null

			}
		},
		// props: ['places','categories'],
		props : {
			places : {
				type : Array,
				required : true
			},
			categories : {
				type : Object,
				required : false
			}
		},
		computed : {
			filteredPlaces : function () {
				let list = this.places;

				if( this.categoryFilter !== '' && this.categoryFilter !== null ) {

					let cat = this.categoryFilter.split( '-' );

					list = list.filter( (item) => {
						return ( item.categories.indexOf( parseInt( cat[1] ) ) > -1);
					} );
				}
				return list;
			}
		},
		methods: {
			toggleInfoWindow : function ( marker, idx ) {

				if( idx === this.activeInfo ) {
					this.infoWindowOpen = false;
					return;
				}

				let infoObject = {
					title : marker.title,
					text : null,
					position : {
						lat: parseFloat(marker.latitude),
						lng: parseFloat(marker.longitude),
					},
					options: {
						pixelOffset: {
							width: 0,
							height: -33
						}
					}
				};
				if( marker.address )
					infoObject.text = '<p>' + marker.address + '</p>';


				this.activeInfo = idx;
				this.infoWindow = infoObject;
				this.infoWindowOpen = true;
			},
			boundMap : function( map ) {
				if( ! this.mapBounds  )
				this.$refs.gmap.$mapPromise.then((map) => {
					let places = this._props.places;

					this.mapBounds = map.getBounds();
					if( this.mapBounds ) {
						for ( let p = 0; p < places.length; p++ ) {
							this.mapBounds.extend( {lat: places[p].latitude, lng: places[p].longitude });
						}

						map.fitBounds( this.mapBounds );
					}

				});
			},
			getIcon : function( category ) {
				let cid = category[0],
						categoryList = this.categories;
				if( typeof cid !== 'undefined' ) {

					if( typeof categoryList[ cid.toString() ] !== 'undefined' ) {
						let cat = Object.assign( categoryList[ cid.toString() ] );

						return cat.icon;
					}
				}

				return null;
			}
		},
		mounted () {
			this.mapBounds = null;
			// console.dir( this.categories );
			Events.$emit( 'showCategories', this.categories );
			Events.$on( "switchContentCategory", ( val ) => this.categoryFilter = val );
		}
	}
</script>

<style scoped>


</style>


// WEBPACK FOOTER //
// src/components/blocks/KappPlace.vue